import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import { useEffect, useState } from "react";
import FormItemInput from "../../components/form-item/form-item-input";
import FormItemInputSelect from "../../components/form-item/form-item-input-select";
import { Form } from "antd";
import FormCard from "../../components/card/FormCard";
import ImageCard from "../../components/card/ImageCard";
import FormItemInputTextarea from "../../components/form-item/form-item-input-textarea";
import FormButton from "../../components/FormButton";
import { useNotify } from "../../helper/notify";
import { GetFullMediaPath, requireRules } from "../../helper/method";
import { statusShowMock, tokenMock } from "../../helper/mock";
import PreviewFile from "../../components/PreviewFile";
import { $api } from "../../helper";
import { useNavigate, useSearchParams } from "react-router";

export default function AddCategory() {
  const [form] = Form.useForm();
  const [searchParams] = useSearchParams();
  const notify = useNotify();
  const navigate = useNavigate();
  const { mutate, isPending } = $api.useMutation(
    "post",
    "/site-api/v1/product/category/",
  );
  const update = $api.useMutation("put", "/site-api/v1/product/category/");
  const detail = $api.useMutation(
    "get",
    "/site-api/v1/product/category-detail/",
  );
  const [file, setFile] = useState<
    {
      file: File | undefined;
      fileUrl: string;
      id: string;
    }[]
  >([]);
  const [fileMobile, setFileMobile] = useState<
    {
      file: File | undefined;
      fileUrl: string;
      id: string;
    }[]
  >([]);
  const { setDashboardName } = useStore(useDashboardName);
  useEffect(() => {
    setDashboardName("ایجاد دسته بندی جدید");
    if (searchParams.get("u_id")) {
      detail.mutate({
        params: {
          query: {
            category_u_id: searchParams.get("u_id") ?? "",
          },
        },
        headers: {
          Authorization: tokenMock,
          lang: "fa",
        },
      });
    }
  }, []);

  useEffect(() => {
    if (detail.data?.data) {
      setFile([
        {
          file: undefined,
          fileUrl: GetFullMediaPath(detail.data.data.desktop_image),
          id: detail.data.data.u_id,
        },
      ]);
      setFileMobile([
        {
          file: undefined,
          fileUrl: GetFullMediaPath(detail.data.data.mobile_image),
          id: detail.data.data.u_id,
        },
      ]);
      Object.entries(detail.data?.data).forEach(([key, value]) => {
        form.setFieldValue(key, value?.toString());
      });
    }
  }, [detail.data]);

  const onFinish = (
    values: {
      title: string;
      status: string;
      seo_title: string;
      seo_description: string;
      slug: string;
    },
    redirect = true,
  ) => {
    const formData = new FormData();
    formData.append("title", values.title);
    formData.append("slug", values.slug);
    formData.append("status", values.status);
    formData.append("seo_title", values.seo_title);
    formData.append("seo_description", values.seo_description);
    if (searchParams.get("u_id")) {
      formData.append(
        "category_u_id",
        searchParams.get("u_id")?.toString() ?? "",
      );
    }
    formData.append(
      "desktop_image",
      file?.at(0)?.file ?? file?.at(0)?.fileUrl ?? "",
    );
    formData.append(
      "mobile_image",
      fileMobile?.at(0)?.file ?? fileMobile?.at(0)?.fileUrl ?? "",
    );
    if (!searchParams.get("u_id")) {
      mutate(
        {
          body: formData,
          headers: {
            Authorization: tokenMock,
            lang: "fa",
          },
        },
        {
          onSuccess: (data) => {
            notify.success(data.message);
            if (redirect) {
              navigate("/category");
            } else {
              setTimeout(() => {
                window.location.href = window.location.pathname;
              }, 1000);
            }
          },
        },
      );
    } else {
      update.mutate(
        {
          body: formData,
          headers: {
            Authorization: tokenMock,
            lang: "fa",
          },
        },
        {
          onSuccess: (data) => {
            notify.success(data.message);
            if (redirect) {
              navigate("/category");
            } else {
              setTimeout(() => {
                window.location.href = window.location.pathname;
              }, 1000);
            }
          },
        },
      );
    }
  };

  return (
    <Form
      form={form}
      onFinish={(e) => onFinish(e, true)}
      layout="vertical"
      className="flex! flex-col! gap-6!"
    >
      <FormCard
        subTitle="تعریف و تنظیمات پایه مربوط به دسته‌بندی"
        title="اطلاعات اصلی دسته‌بندی"
      >
        <div className="grid sm:grid-cols-2 grid-cols-1 w-full gap-6">
          <FormItemInput
            name={"title"}
            rules={requireRules("نام دسته")}
            className="col-span-1"
            label="نام دسته بندی"
            inputProps={{
              placeholder: "لطفا نام دسته بندی خود را وارد کنید.",
            }}
          />
          <FormItemInput
            name={"slug"}
            rules={requireRules("اسلاگ")}
            className="col-span-1"
            label="اسلاگ"
            inputProps={{
              placeholder: "لطفا اسلاگ خود را وارد کنید.",
            }}
          />
          <FormItemInputSelect
            className="col-span-1"
            rules={requireRules("وضعیت")}
            name={"status"}
            label="وضعیت"
            inputProps={{
              placeholder: "لطفا وضعیت نمایش محصول خود را انتخاب کنید.",
              options: statusShowMock,
            }}
          />
        </div>
      </FormCard>
      <FormCard
        subTitle="تصاویر مربوط به نمایش دسته‌بندی در نسخه‌های مختلف"
        title="تصاویر دسته‌بندی"
      >
        <div className="grid sm:grid-cols-2 grid-cols-1 w-full gap-6">
          <div className="col-span-1 flex h-fit flex-col gap-2">
            <ImageCard
              file={file}
              setFile={setFile}
              id="image1-1"
              name="desktop_image"
            />
            {file?.map((e, i) => (
              <div className="w-40 h-40">
                <PreviewFile
                  id={e.id}
                  setFile={setFile}
                  url={e.fileUrl}
                  key={"preview-category" + i}
                />
              </div>
            ))}
          </div>
          <div className="col-span-1 flex h-fit flex-col gap-2">
            <ImageCard
              mobile
              file={fileMobile}
              setFile={setFileMobile}
              id="image2-2"
              name="mobile_image"
            />
            {fileMobile?.map((e, i) => (
              <div className="w-40 h-40">
                <PreviewFile
                  id={e.id}
                  setFile={setFileMobile}
                  url={e.fileUrl}
                  key={"preview-mobile-category" + i}
                />
              </div>
            ))}
          </div>
        </div>
      </FormCard>
      <FormCard
        title="اطلاعات سئو"
        subTitle="بهینه‌سازی دسته‌بندی برای موتورهای جستجو"
      >
        <div className="grid sm:grid-cols-2 grid-cols-1 w-full gap-6">
          <FormItemInput
            rules={requireRules("عنوان سئو")}
            name={"seo_title"}
            label="عنوان سئو"
            className="col-span-1"
            inputProps={{
              placeholder: "لطفا عنوان سئو خود را وارد کنید.",
            }}
          />
          <FormItemInputTextarea
            rules={requireRules("توضیحات سئو")}
            label="توضیحات"
            name={"seo_description"}
            className="col-span-1"
            inputProps={{
              className: "resize-none!",
              rows: 4,
              placeholder: "لطفا توضیحات اضافی سئو خود را بنویسید...",
            }}
          />
        </div>
      </FormCard>
      <FormButton
        isPending={isPending || update.isPending}
        ActionSaveAndStay={() => {
          form.validateFields().then(() => {
            onFinish(form.getFieldsValue(), false);
          });
        }}
      />
    </Form>
  );
}
